(function () {
  function parseProduct(root) {
    const script = root.querySelector('[data-erpdp-product-json]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  }

  function parseVariantMediaMap(root) {
    const script = root.querySelector('[data-erpdp-variant-media-json]');
    if (!script) return {};
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return {};
    }
  }

  function parseVariantPriceMap(root) {
    const script = root.querySelector('[data-erpdp-variant-price-json]');
    if (!script) return {};
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return {};
    }
  }

  function money(cents, currencyCode, locale, currencySymbol) {
    if (typeof cents !== 'number') return '';
    const code = String(currencyCode || 'USD').toUpperCase();
    try {
      const formatted = new Intl.NumberFormat(locale || undefined, {
        style: 'currency',
        currency: code,
        currencyDisplay: 'narrowSymbol',
      }).format(cents / 100);
      return `${formatted} ${code}`;
    } catch (error) {
      return `${currencySymbol || '$'}${(cents / 100).toLocaleString(locale || undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })} ${code}`;
    }
  }

  function initGallery(root) {
    const main = root.querySelector('[data-erpdp-main-image]');
    const thumbs = Array.from(root.querySelectorAll('[data-erpdp-thumb]'));
    if (!main || !thumbs.length) return null;

    function activateThumb(thumb) {
      const src = thumb.dataset.src;
      if (!src) return false;
      const srcset = thumb.dataset.srcset;
      if (srcset) {
        main.srcset = srcset;
        main.sizes = thumb.dataset.sizes || '(max-width: 749px) calc(100vw - 32px), (max-width: 1199px) 52vw, 680px';
      } else {
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
      }
      main.src = src;
      main.alt = thumb.dataset.alt || '';
      main.dataset.mediaId = thumb.dataset.mediaId || '';
      thumbs.forEach((item) => item.classList.toggle('is-active', item === thumb));
      return true;
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => activateThumb(thumb));
    });

    const swipeArea = main.closest('.erpdp-gallery-main');
    if (swipeArea) {
      const activePointers = new Set();
      let gesture = null;

      function visibleThumbs() {
        // Lite's mobile hero is a separate control, not a standard product thumb.
        return Array.from(root.querySelectorAll('[data-erpdp-thumb], [data-er-lite-hero-thumb]'))
          .filter((thumb) => !thumb.hidden && !thumb.disabled && thumb.dataset.src
            && thumb.getClientRects().length && window.getComputedStyle(thumb).visibility !== 'hidden');
      }

      function revealThumb(thumb) {
        const strip = thumb.closest('.erpdp-gallery-thumbs');
        if (!strip || strip.scrollWidth <= strip.clientWidth) return;
        const bounds = strip.getBoundingClientRect();
        const imageBounds = thumb.getBoundingClientRect();
        const left = bounds.left + strip.clientLeft;
        const right = left + strip.clientWidth;
        // Never use scrollIntoView here: it can also move the whole product page.
        if (imageBounds.left < left) strip.scrollLeft += imageBounds.left - left;
        else if (imageBounds.right > right) strip.scrollLeft += imageBounds.right - right;
      }

      swipeArea.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
        activePointers.add(event.pointerId);
        gesture = activePointers.size === 1 && event.isPrimary !== false
          ? { id: event.pointerId, x: event.clientX, y: event.clientY, axis: null }
          : null;
        // Keep the end/cancel event local even when the finger leaves the image.
        try { swipeArea.setPointerCapture(event.pointerId); } catch (error) { /* No active pointer. */ }
      }, { passive: true });

      swipeArea.addEventListener('pointermove', (event) => {
        if (!gesture || event.pointerId !== gesture.id || gesture.axis) return;
        const dx = Math.abs(event.clientX - gesture.x);
        const dy = Math.abs(event.clientY - gesture.y);
        if (Math.max(dx, dy) < 10) return;
        // Lock out vertical/diagonal starts so scrolling cannot become a swipe.
        gesture.axis = dx > dy * 1.5 ? 'horizontal' : 'other';
      }, { passive: true });

      swipeArea.addEventListener('pointerup', (event) => {
        activePointers.delete(event.pointerId);
        if (!gesture || event.pointerId !== gesture.id) return;
        const completed = gesture;
        gesture = null;
        const dx = event.clientX - completed.x;
        const dy = event.clientY - completed.y;
        if (activePointers.size || completed.axis === 'other'
          || Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy) * 1.5) return;
        const available = visibleThumbs();
        if (available.length < 2) return;
        const index = available.findIndex((thumb) => thumb.classList.contains('is-active'));
        const nextIndex = index < 0 ? (dx < 0 ? 0 : available.length - 1)
          : (index + (dx < 0 ? 1 : -1) + available.length) % available.length;
        const next = available[nextIndex];
        // Reuse all existing handlers, including Lite's responsive picture source.
        next.click();
        revealThumb(next);
      }, { passive: true });

      function cancelGesture(event) {
        activePointers.delete(event.pointerId);
        if (gesture?.id === event.pointerId) gesture = null;
      }
      swipeArea.addEventListener('pointercancel', cancelGesture, { passive: true });
      swipeArea.addEventListener('lostpointercapture', cancelGesture, { passive: true });
    }

    return {
      selectMedia(media) {
        if (!media) return false;
        const mediaId = typeof media === 'object' ? media.id : media;
        const match = thumbs.find((thumb) => String(thumb.dataset.mediaId) === String(mediaId));
        if (match) return activateThumb(match);
        if (typeof media !== 'object' || !media.src) return false;
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src = media.src;
        main.alt = media.alt || '';
        main.dataset.mediaId = mediaId || '';
        thumbs.forEach((thumb) => thumb.classList.remove('is-active'));
        return true;
      },
    };
  }

  function initCountdown(root) {
    const countdown = root.querySelector('[data-erpdp-countdown]');
    if (!countdown || countdown.dataset.countdownInitialized === 'true') return;
    countdown.dataset.countdownInitialized = 'true';

    const deadline = Date.parse(countdown.dataset.countdownEnd || '');
    if (!Number.isFinite(deadline)) {
      countdown.hidden = true;
      return;
    }

    const values = {
      days: countdown.querySelector('[data-countdown-days]'),
      hours: countdown.querySelector('[data-countdown-hours]'),
      minutes: countdown.querySelector('[data-countdown-minutes]'),
      seconds: countdown.querySelector('[data-countdown-seconds]'),
    };
    const expiredMessage = countdown.querySelector('[data-countdown-expired-message]');
    let timerId;

    function format(value) {
      return String(Math.max(0, value)).padStart(2, '0');
    }

    function render() {
      const remaining = deadline - Date.now();
      if (remaining <= 0) {
        countdown.classList.add('is-expired');
        const source = countdown.closest('[data-erpdp-global-countdown-source]');
        if (source && source.dataset.countdownHideExpired !== 'false' && !window.Shopify?.designMode) {
          source.hidden = true;
          document.querySelectorAll('[data-erpdp-countdown-slot]').forEach((slot) => {
            slot.hidden = true;
            slot.style.height = '';
          });
          const wrapper = source.closest('.shopify-section');
          if (typeof wrapper?.erpdpCountdownCleanup === 'function') wrapper.erpdpCountdownCleanup();
          if (timerId) window.clearInterval(timerId);
          return;
        }
        if (expiredMessage) {
          expiredMessage.textContent = countdown.dataset.countdownExpired || 'This offer has ended.';
          expiredMessage.hidden = false;
        }
        if (timerId) window.clearInterval(timerId);
        return;
      }

      const totalSeconds = Math.floor(remaining / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      if (values.days) values.days.textContent = format(days);
      if (values.hours) values.hours.textContent = format(hours);
      if (values.minutes) values.minutes.textContent = format(minutes);
      if (values.seconds) values.seconds.textContent = format(seconds);
    }

    render();
    if (!countdown.classList.contains('is-expired')) {
      timerId = window.setInterval(render, 1000);
    }
  }

  function mountGlobalCountdown(root) {
    const slot = root.querySelector('[data-erpdp-countdown-slot]');
    const source = document.querySelector('[data-erpdp-global-countdown-source]');
    if (!slot || !source) return;

    const sectionWrapper = source.closest('.shopify-section') || source;
    const headerGroup = document.querySelector('#header-group');
    const countdown = source.querySelector('[data-erpdp-countdown]');
    const deadline = Date.parse(countdown?.dataset.countdownEnd || '');
    const expired = Number.isFinite(deadline) && deadline <= Date.now();
    const enabled = source.dataset.countdownEnabled === 'true' && countdown && Number.isFinite(deadline)
      && (!expired || source.dataset.countdownHideExpired === 'false' || window.Shopify?.designMode);

    if (typeof sectionWrapper.erpdpCountdownCleanup === 'function') {
      sectionWrapper.erpdpCountdownCleanup();
    }
    if (headerGroup && sectionWrapper.parentElement !== headerGroup) {
      headerGroup.appendChild(sectionWrapper);
    }

    slot.replaceChildren();
    source.hidden = !enabled;
    slot.hidden = !enabled;
    if (!enabled) {
      slot.style.height = '';
      sectionWrapper.removeAttribute('style');
      return;
    }

    sectionWrapper.style.position = 'fixed';
    sectionWrapper.style.zIndex = '4';
    sectionWrapper.style.margin = '0';

    let frameId = 0;
    const positionCountdown = () => {
      window.cancelAnimationFrame(frameId);
      frameId = window.requestAnimationFrame(() => {
        const rect = slot.getBoundingClientRect();
        sectionWrapper.style.left = `${rect.left}px`;
        sectionWrapper.style.top = `${rect.top}px`;
        sectionWrapper.style.width = `${rect.width}px`;
        const height = sectionWrapper.getBoundingClientRect().height;
        if (height > 0) slot.style.height = `${height}px`;
      });
    };

    window.addEventListener('scroll', positionCountdown, { passive: true });
    window.addEventListener('resize', positionCountdown);
    const observer = new ResizeObserver(positionCountdown);
    observer.observe(slot);
    observer.observe(sectionWrapper);
    sectionWrapper.erpdpCountdownCleanup = () => {
      window.cancelAnimationFrame(frameId);
      window.removeEventListener('scroll', positionCountdown);
      window.removeEventListener('resize', positionCountdown);
      observer.disconnect();
    };
    positionCountdown();
    initCountdown(source);
  }

  function initRating(root) {
    root.querySelectorAll('[data-erpdp-rating]').forEach((rating) => {
      if (rating.dataset.ratingInitialized === 'true') return;
      rating.dataset.ratingInitialized = 'true';
      const badge = rating.querySelector('.jdgm-preview-badge');
      const fallback = rating.querySelector('[data-erpdp-rating-fallback]');
      if (!fallback) return;

      // Judge.me can return valid review data while its preview-star font is
      // disabled, leaving five zero-width star elements and only the review
      // count visible. The Liquid fallback uses the same published Shopify
      // rating metafields and remains reliable regardless of app styling.
      fallback.hidden = false;
      if (badge) {
        badge.hidden = true;
        badge.style.setProperty('display', 'none', 'important');
      }
    });
  }

  function initPurchase(root) {
    if (root.dataset.erpdpInitialized === 'true') return;
    root.dataset.erpdpInitialized = 'true';
    const gallery = initGallery(root);
    mountGlobalCountdown(root);
    initCountdown(root);
    initRating(root);

    const product = parseProduct(root);
    if (!product || !Array.isArray(product.variants)) return;
    const variantMediaMap = parseVariantMediaMap(root);
    const variantPriceMap = parseVariantPriceMap(root);

    const variantInput = root.querySelector('[data-erpdp-variant-id]');
    const acceleratedCheckout = root.querySelector('[data-erpdp-accelerated-checkout]');
    const price = root.querySelector('[data-erpdp-price]');
    const comparePrice = root.querySelector('[data-erpdp-compare-price]');
    const savings = root.querySelector('[data-erpdp-savings]');
    const priceWrap = root.querySelector('.erpdp-price');
    const addButton = root.querySelector('[data-erpdp-add]');
    const buyNowButton = root.querySelector('[data-erpdp-buy-now]');
    const addPrice = root.querySelector('[data-erpdp-add-price]');
    const mobileAddButton = root.querySelector('[data-erpdp-mobile-add]');
    const mobileAddLabel = mobileAddButton?.querySelector('[data-erpdp-mobile-label]') || mobileAddButton;
    const mobileModel = mobileAddButton?.querySelector('[data-erpdp-mobile-model]');
    const modelButtons = Array.from(root.querySelectorAll('[data-erpdp-model]'));
    const packageButtons = Array.from(root.querySelectorAll('[data-erpdp-package]'));
    const directButtons = Array.from(root.querySelectorAll('[data-erpdp-variant]'));
    const fulfillment = root.querySelector('[data-erpdp-fulfillment]');
    const stockLabel = root.querySelector('[data-erpdp-stock-label]');
    const stockDetail = root.querySelector('[data-erpdp-stock-detail]');
    const advancedToggle = root.querySelector('[data-erpdp-advanced-toggle]');
    const advancedToggleLabel = root.querySelector('[data-erpdp-advanced-toggle-label]');
    const currencySymbol = root.dataset.currencySymbol || '$';
    const currencyCode = root.dataset.currencyCode || 'USD';
    const currencyLocale = root.dataset.currencyLocale || document.documentElement.lang || undefined;

    function formattedVariantPrice(variant, key) {
      if (!variant) return '';
      const priceKey = key || 'price';
      const serverPrice = variantPriceMap[String(variant.id)]?.[priceKey];
      if (serverPrice) return serverPrice;
      return money(Number(variant[priceKey] || 0), currencyCode, currencyLocale, currencySymbol);
    }

    function setVariant(variant) {
      if (!variant || !variantInput) return;
      variantInput.value = variant.id;
      if (acceleratedCheckout) acceleratedCheckout.hidden = !variant.available;
      if (price) price.textContent = formattedVariantPrice(variant, 'price');
      const compareAtPrice = Number(variant.compare_at_price || 0);
      const salePrice = Number(variant.price || 0);
      const isOnSale = compareAtPrice > salePrice;
      if (comparePrice) {
        comparePrice.hidden = !isOnSale;
        comparePrice.textContent = isOnSale ? formattedVariantPrice(variant, 'compare_at_price') : '';
      }
      if (savings) {
        const savingsPercent = isOnSale ? Math.round(((compareAtPrice - salePrice) / compareAtPrice) * 100) : 0;
        savings.hidden = !isOnSale;
        savings.textContent = isOnSale ? `Save ${savingsPercent}%` : '';
      }
      if (priceWrap) priceWrap.classList.toggle('is-sale', isOnSale);
      if (addPrice) addPrice.textContent = formattedVariantPrice(variant, 'price');
      root.querySelectorAll('[data-erpdp-mobile-price]').forEach((mobilePrice) => {
        mobilePrice.textContent = formattedVariantPrice(variant, 'price');
      });
      root.querySelectorAll('[data-erpdp-mobile-compare]').forEach((mobileCompare) => {
        mobileCompare.hidden = !isOnSale;
        mobileCompare.textContent = isOnSale ? formattedVariantPrice(variant, 'compare_at_price') : '';
      });
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.querySelector('span').textContent = variant.available
          ? addButton.dataset.availableText
          : addButton.dataset.soldoutText;
      }
      if (buyNowButton) {
        buyNowButton.disabled = !variant.available;
        buyNowButton.querySelector('span').textContent = variant.available
          ? buyNowButton.dataset.availableText
          : buyNowButton.dataset.soldoutText;
      }
      if (mobileAddButton) {
        mobileAddButton.disabled = !variant.available;
        mobileAddButton.removeAttribute('aria-busy');
        mobileAddLabel.textContent = variant.available
          ? mobileAddButton.dataset.availableText
          : mobileAddButton.dataset.soldoutText;
        const selectedModel = modelButtons.find((button) => button.classList.contains('is-active'));
        if (mobileModel && selectedModel) {
          mobileModel.textContent = selectedModel.querySelector('strong')?.textContent || selectedModel.dataset.erpdpModel;
        }
      }
      if (fulfillment) fulfillment.classList.toggle('is-sold-out', !variant.available);
      if (stockLabel) {
        stockLabel.textContent = variant.available
          ? stockLabel.dataset.availableText
          : stockLabel.dataset.soldoutText;
      }
      if (stockDetail) {
        stockDetail.textContent = variant.available
          ? stockDetail.dataset.availableText
          : stockDetail.dataset.soldoutText;
      }
      directButtons.forEach((button) => {
        button.classList.toggle('is-active', String(button.dataset.erpdpVariant) === String(variant.id));
        button.setAttribute('aria-pressed', String(button.classList.contains('is-active')));
      });
      if (gallery) gallery.selectMedia(variantMediaMap[String(variant.id)] || variant.featured_image);
      // Native accelerated checkout reads the same product form as Add to cart.
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function findGuidedVariant(modelMatch, packageMatch) {
      const normalizedModel = (modelMatch || '').trim().toLowerCase();
      const normalizedPackage = (packageMatch || '').trim().toLowerCase();
      if (!normalizedModel || !normalizedPackage) return null;

      const exactTitle =
        normalizedPackage === '__base__' ? normalizedModel : `${normalizedModel} ${normalizedPackage}`;
      const exactVariant = product.variants.find((item) => item.title.trim().toLowerCase() === exactTitle);
      if (exactVariant) return exactVariant;

      return (
        product.variants.find((item) => {
          const title = item.title.trim().toLowerCase();
          if (!title.startsWith(normalizedModel)) return false;
          return normalizedPackage === '__base__'
            ? title === normalizedModel
            : title.includes(normalizedPackage);
        }) || null
      );
    }

    function selectedModelMatch() {
      const selectedModel = modelButtons.find((button) => button.classList.contains('is-active'));
      return selectedModel ? selectedModel.dataset.erpdpModel || '' : '';
    }

    function advancedIsOpen() {
      return advancedToggle?.getAttribute('aria-expanded') === 'true';
    }

    function syncAdvancedToggleLabel() {
      if (!advancedToggle || !advancedToggleLabel) return;
      advancedToggleLabel.textContent = advancedIsOpen()
        ? advancedToggle.dataset.closeText
        : advancedToggle.dataset.openText;
    }

    function syncPackageOptions(modelMatch) {
      packageButtons.forEach((button) => {
        const variant = findGuidedVariant(modelMatch, button.dataset.erpdpPackage || '');
        const priceLabel = button.querySelector('[data-erpdp-package-price]');
        const isAdvanced = button.hasAttribute('data-erpdp-advanced-option');
        button.dataset.erpdpHasVariant = String(Boolean(variant));
        button.hidden = !variant || (isAdvanced && !advancedIsOpen());
        button.disabled = !variant;
        button.setAttribute('aria-disabled', String(!variant));
        if (priceLabel) {
          const hasComparePrice = variant && Number(variant.compare_at_price || 0) > Number(variant.price || 0);
          priceLabel.textContent = variant
            ? `${formattedVariantPrice(variant, 'price')}${hasComparePrice ? ` · Was ${formattedVariantPrice(variant, 'compare_at_price')}` : ''}`
            : '';
        }
      });
    }

    function chooseGuidedVariant() {
      const modelMatch = selectedModelMatch();
      const selectedPackage = packageButtons.find(
        (button) => button.classList.contains('is-active') && !button.hidden,
      );
      if (!modelMatch || !selectedPackage) return;

      const variant = findGuidedVariant(modelMatch, selectedPackage.dataset.erpdpPackage || '');
      if (variant) setVariant(variant);
    }

    modelButtons.forEach((button) => {
      button.addEventListener('click', () => {
        modelButtons.forEach((item) => item.classList.toggle('is-active', item === button));
        modelButtons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        if (advancedToggle) advancedToggle.setAttribute('aria-expanded', 'false');
        syncAdvancedToggleLabel();
        syncPackageOptions(button.dataset.erpdpModel || '');
        const basePackage =
          packageButtons.find((item) => item.dataset.erpdpPackage === '__base__' && !item.hidden) ||
          packageButtons.find((item) => !item.hidden);
        packageButtons.forEach((item) => item.classList.toggle('is-active', item === basePackage));
        packageButtons.forEach((item) =>
          item.setAttribute('aria-pressed', String(item === basePackage)),
        );
        chooseGuidedVariant();
      });
    });

    if (advancedToggle) {
      advancedToggle.addEventListener('click', () => {
        advancedToggle.setAttribute('aria-expanded', String(!advancedIsOpen()));
        syncAdvancedToggleLabel();
        syncPackageOptions(selectedModelMatch());
      });
    }

    packageButtons.forEach((button) => {
      button.addEventListener('click', () => {
        packageButtons.forEach((item) => item.classList.toggle('is-active', item === button));
        packageButtons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        chooseGuidedVariant();
      });
    });

    directButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const variant = product.variants.find((item) => String(item.id) === String(button.dataset.erpdpVariant));
        if (variant) setVariant(variant);
      });
    });

    const minus = root.querySelector('[data-erpdp-minus]');
    const plus = root.querySelector('[data-erpdp-plus]');
    const quantity = root.querySelector('[data-erpdp-quantity]');
    if (minus && plus && quantity) {
      minus.addEventListener('click', () => {
        quantity.value = String(Math.max(1, Number(quantity.value || 1) - 1));
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      });
      plus.addEventListener('click', () => {
        quantity.value = String(Math.min(20, Number(quantity.value || 1) + 1));
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    if (buyNowButton && variantInput) {
      buyNowButton.addEventListener('click', () => {
        const variantId = String(variantInput.value || '').replace(/\D/g, '');
        const requestedQuantity = Math.min(20, Math.max(1, Number(quantity?.value || 1)));
        const rootUrl = (root.dataset.rootUrl || '/').replace(/\/?$/, '/');
        if (!variantId || buyNowButton.disabled) return;

        buyNowButton.setAttribute('aria-busy', 'true');
        window.location.assign(`${rootUrl}cart/${encodeURIComponent(variantId)}:${requestedQuantity}`);
      });
    }

    if (mobileAddButton && addButton) {
      const floatingBar = mobileAddButton.closest('.erpdp-mobile-cart--floating');
      if (floatingBar && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => {
          floatingBar.classList.toggle('erpdp-mobile-cart--main-visible', entry.isIntersecting);
        }, { threshold: 0.5 });
        observer.observe(addButton);
        const dispose = (event) => {
          if (!event.target.contains(root)) return;
          observer.disconnect();
          document.removeEventListener('shopify:section:unload', dispose);
        };
        document.addEventListener('shopify:section:unload', dispose);
      }
      mobileAddButton.addEventListener('click', () => {
        if (mobileAddButton.disabled || addButton.disabled) return;
        addButton.click();
      });
      const productForm = variantInput?.closest('form');
      productForm?.addEventListener('submit', (event) => {
        queueMicrotask(() => {
          if (event.defaultPrevented || !root.isConnected) return;
          mobileAddButton.disabled = true;
          mobileAddButton.setAttribute('aria-busy', 'true');
        });
      });
      window.addEventListener('pageshow', () => {
        if (!root.isConnected) return;
        mobileAddButton.disabled = addButton.disabled;
        mobileAddButton.removeAttribute('aria-busy');
      });
    }

    const initialId = variantInput ? variantInput.value : '';
    const initial = product.variants.find((item) => String(item.id) === String(initialId)) || product.variants[0];
    setVariant(initial);
    if (modelButtons.length && packageButtons.length) {
      syncAdvancedToggleLabel();
      syncPackageOptions(selectedModelMatch());
      chooseGuidedVariant();
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-erpdp-purchase]').forEach(initPurchase);
  }

  document.addEventListener('click', (event) => {
    const guide = event.target.closest('[data-erpdp-guide]');
    if (!guide) return;

    const purchase = document.querySelector('[data-erpdp-purchase]');
    if (!purchase) return;

    const modelMatch = (guide.dataset.erpdpSelectModel || '').trim().toLowerCase();
    const packageMatch = (guide.dataset.erpdpSelectPackage || '').trim().toLowerCase();
    const modelButton = Array.from(purchase.querySelectorAll('[data-erpdp-model]')).find(
      (button) => (button.dataset.erpdpModel || '').trim().toLowerCase() === modelMatch,
    );

    if (modelMatch && !modelButton) return;
    event.preventDefault();

    if (modelButton) modelButton.click();

    if (packageMatch) {
      const packageButton = Array.from(purchase.querySelectorAll('[data-erpdp-package]')).find(
        (button) =>
          (button.dataset.erpdpPackage || '').trim().toLowerCase() === packageMatch,
      );
      if (packageButton?.hasAttribute('data-erpdp-advanced-option') && packageButton.hidden) {
        const advancedToggle = purchase.querySelector('[data-erpdp-advanced-toggle]');
        if (advancedToggle?.getAttribute('aria-expanded') !== 'true') advancedToggle?.click();
      }
      if (packageButton) packageButton.click();
    }

    purchase.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  function refreshGlobalCountdowns() {
    document.querySelectorAll('[data-erpdp-purchase]').forEach((root) => {
      mountGlobalCountdown(root);
      initCountdown(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
    if (event.target.querySelector('[data-erpdp-global-countdown-source]')) {
      refreshGlobalCountdowns();
    }
  });
})();
